import {
  AppScrollView,
  AppShell,
  AppViewport,
  HomeframeInput,
  HomeframeProvider,
} from '@builtbyted/homeframe';
import React from 'react';
import { createRoot } from 'react-dom/client';
import themes from 'Styles/Themes';
import styles from './Homeframe/SignIn.css';
import PasskeySignIn from './Homeframe/PasskeySignIn';

import 'Styles/globals.css';
import '@builtbyted/homeframe/styles.css';
import './Homeframe/homeframe.css';

const config = (
  window as unknown as {
    showrunnerLogin: {
      urlBase: string;
      theme: keyof typeof themes;
      passkeys: boolean;
    };
  }
).showrunnerLogin;
Object.entries(themes[config.theme] ?? themes.auto).forEach(([key, value]) => {
  document.documentElement.style.setProperty(`--${key}`, value);
});

function SignIn() {
  const failed =
    new URLSearchParams(window.location.search).get('loginFailed') === 'true';
  return (
    <HomeframeProvider config={{ serviceWorker: false, notifications: false }}>
      <AppViewport>
        <AppShell
          header={
            <div className={styles.header}>
              <img
                src={`${config.urlBase}/Content/Images/showrunner.png`}
                alt=""
              />
              <span>Showrunner</span>
            </div>
          }
        >
          <AppScrollView>
            {config.passkeys ? (
              <PasskeySignIn urlBase={config.urlBase} />
            ) : (
              <form method="POST" className={styles.form} aria-label="Sign in">
                <h1>Sign in to Showrunner</h1>
                <label htmlFor="username">Username</label>
                <HomeframeInput
                  className={styles.textInput}
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="username"
                  autoCapitalize="none"
                  required={true}
                />
                <label htmlFor="password">Password</label>
                <HomeframeInput
                  className={styles.textInput}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required={true}
                />
                <label className={styles.remember}>
                  <HomeframeInput
                    name="rememberMe"
                    type="checkbox"
                    defaultChecked={true}
                  />{' '}
                  Remember me
                </label>
                <button type="submit">Sign in</button>
                {failed ? (
                  <p role="alert">Incorrect username or password.</p>
                ) : null}
                <p className={styles.attribution}>
                  Showrunner
                </p>
              </form>
            )}
          </AppScrollView>
        </AppShell>
      </AppViewport>
    </HomeframeProvider>
  );
}

createRoot(document.getElementById('root')!).render(<SignIn />);
